import { api, unwrap, toPaginated, cleanParams } from "../lib/axios";
import type { ApiEnvelope, ListParams, PaginatedResult } from "../types/api";
import type { AppUser, UserStatus } from "../types/domain";

export const usersApi = {
  async list(params: ListParams): Promise<PaginatedResult<AppUser>> {
    const res = await api.get<ApiEnvelope<unknown>>("/user/all", {
      params: cleanParams(params),
    });
    return toPaginated<AppUser>(res, "users");
  },

  async get(id: string): Promise<AppUser> {
    const res = await api.get<ApiEnvelope<AppUser>>(`/user/${id}`);
    return unwrap(res);
  },

  async setStatus(
    id: string,
    status: UserStatus,
    reason?: string,
  ): Promise<AppUser> {
    const res = await api.patch<ApiEnvelope<AppUser>>(`/user/${id}/status`, {
      status,
      reason,
    });
    return unwrap(res);
  },
};
